/** Map FCM notification `data.type` → admin route */
export const NOTIFICATION_TYPE_ROUTES = {
  broker_pending_approval: "/dashboard/customers/user-approvals",
  broker_approval: "/dashboard/customers/user-approvals",
  broker_request: "/dashboard/customers/user-approvals",
  user_approval: "/dashboard/customers/user-approvals",
  announcement_pending: "/dashboard/announcements/approval",
  announcement_pending_approval: "/dashboard/announcements/approval",
  announcement_approval: "/dashboard/announcements/approval",
  new_announcement: "/dashboard/announcements/approval",
  announcement_created: "/dashboard/announcements/approval",
  announcement_active: "/dashboard/announcements/active",
  announcement_approved: "/dashboard/announcements/active",
};

export const USER_APPROVAL_NOTIFICATION_TYPES = [
  "broker_pending_approval",
  "broker_approval",
  "broker_request",
  "user_approval",
];

function normalizeType(type) {
  if (type == null || type === "") return null;
  return String(type).trim().toLowerCase();
}

export function resolveNotificationLink(data) {
  if (!data || typeof data !== "object") return null;
  if (data.link) return data.link;
  if (data.url) return data.url;
  if (data.path) return data.path;
  if (data.redirect_url) return data.redirect_url;

  const type = normalizeType(data.type);
  if (type && NOTIFICATION_TYPE_ROUTES[type]) {
    return NOTIFICATION_TYPE_ROUTES[type];
  }
  return null;
}

export function isUserApprovalNotification(item) {
  const type = normalizeType(item?.type || item?.data?.type);
  return Boolean(type && USER_APPROVAL_NOTIFICATION_TYPES.includes(type));
}

export function getNotificationNavigationPath(item) {
  if (!item) return null;
  if (item.link) return item.link;

  const fromData = resolveNotificationLink(item.data);
  if (fromData) return fromData;

  const type = normalizeType(item.type);
  if (type && NOTIFICATION_TYPE_ROUTES[type]) {
    return NOTIFICATION_TYPE_ROUTES[type];
  }

  // Heuristic fallback from title/body when backend omits type
  const text = `${item.title || ""} ${item.body || ""}`.toLowerCase();
  if (text.includes("broker") && (text.includes("approv") || text.includes("request") || text.includes("pending"))) {
    return "/dashboard/customers/user-approvals";
  }
  if (text.includes("announcement") && (text.includes("approv") || text.includes("pending") || text.includes("new"))) {
    return "/dashboard/announcements/approval";
  }

  return null;
}
